import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const StickyMobileCta = ({ to, btnCls = "bg-primary" }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div data-testid="mobile-cta"
      className={`md:hidden fixed bottom-0 inset-x-0 z-50 px-4 pb-4 pt-3 bg-[#1B263B]/85 backdrop-blur-xl border-t border-white/10 transition-[transform,opacity] duration-300 ${show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
      <Link to={to} data-testid="mobile-cta-button"
        className={`flex items-center justify-center gap-2 rounded-full ${btnCls} text-white py-3.5 font-bold active:scale-95 transition-[transform] duration-200`}>
        Start je trip gratis <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};
